import useAuthorizedRequest from 'containers/Api2/useAuthorizedRequest.js';
import useRecoveredData from 'utils/useRecoveredData.js';
import { addItem } from 'utils/useApi3/reduceObjects.js';
import useUpdateTopics from '../useUpdateTopics.js';
import useConversationsContext from '../useConversationsContext.js';

function useInlineEdit(post) {
  const { media = [], newMedia = [], ...rest } = post || {};
  const { baseUrl, inboxId, setInTopics, currentId, topics, setTopics } = useConversationsContext();
  const [storedData, setStoredData] = useRecoveredData('topics', inboxId, 'msg', post.topicId, post?.id || 'new');
  const { authPost } = useAuthorizedRequest();
  const updateTopics = useUpdateTopics({ baseUrl, topics, setTopics });
  const defaultValues = {
    files: { media, newMedia },
    ...rest,
    ...storedData,
  };

  async function handleSubmit(data) {
    const { files, id, body } = data;
    const postBody = {
      postMedia: files.newMedia.map((o) => o.data),
      media: files.media,
      body,
      id,
    };
    const message = await authPost({
      url: `${baseUrl}/${currentId}/messages`,
      body: postBody,
      // noReport: [500],
      skipParseDates: true,
    });
    setInTopics([currentId, 'messages'], addItem(message));
    updateTopics();
  }

  function handleChange(values) {
    setStoredData(values);
  }

  return { defaultValues, handleSubmit, handleChange };
}
export default useInlineEdit;
